<template>
  <a-tabs :default-active-key="1" tab-position="left">
    <a-tab-pane :key="1" tab="进行中流程" style="margin-left: -24px;">
      <CcMeRuntimeModal ref="CcMeRuntimeModal"></CcMeRuntimeModal>
    </a-tab-pane>
    <a-tab-pane :key="2" tab="终了流程" style="margin-left: -24px;">
      <CcMeHistoryModal ref="CcMeHistoryModal"></CcMeHistoryModal>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import { putAction, postAction, getAction } from '@/api/manage'
import CcMeRuntimeModal from './modules/CcMeRuntimeModal'
import CcMeHistoryModal from './modules/CcMeHistoryModal'

export default {
  name: 'CcMeManage',
  components: {
    CcMeRuntimeModal,
    CcMeHistoryModal
  },
  data() {
    return {
      description: '任務管理画面',
      // スタート条件
      startParam: {},
      // 検索条件
      queryParam: {},
      // テーブルタイトル
      columns: [],
      url: {}
    }
  },
  methods: {}
}
</script>
<style lang="less" scoped>
.ant-tabs {
  :global(.ant-tabs-left-bar) {
    padding: 10px 0;
  }
}

// /deep/ .ant-table-row-cell-ellipsis {
//   white-space: unset;
// }
</style>
